/**
 * 微信分享，qq分享
 * @param shareOptions {Object} - 分享参数
 * @param options.title {String} - 分享标题
 * @param options.desc {String} - 分享简介
 * @param options.link {String} - 分享跳转链接
 * @param options.imgUrl {String} - 分享图片
 * @param options.success {Function} - 用户确认分享后执行的回调函数, 用于埋点
 */

import http from '../server/http'

const WX_SHARE_API = 'https://wapapi.nfapp.southcn.com/nfplus-wap-api/wx/getShareSignInfo'

// 是否已经初始化过微信分享，如果初始化了，则无需再请求签名
let isInitWxShare = false

// 获取公众号信息
const getWxPublic = () => {
  return new Promise(resolve => {
    const shareUrl = window.location.href.split('#')[0]
    const sendData = {
      shareUrl: encodeURIComponent(shareUrl)
    }
    // 兄弟，千万别想不开，这个东西拼接参数一定要在url后面拼接，别想不开写在params对象里传入进去
    const url = `${WX_SHARE_API}?shareUrl=${sendData.shareUrl}`
    http
      .get({ url, showLoading: false, showToast: false })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        window.console.warn(err)
        resolve(false)
      })
  })
}

const setShareInfo = shareOptions => {
  // 分享到朋友圈
  window.wx.onMenuShareTimeline(Object.assign({}, shareOptions, { shareChanel: '2' }))
  // 分享给朋友
  window.wx.onMenuShareAppMessage(Object.assign({}, shareOptions, { shareChanel: '1' }))
  // 分享到QQ
  window.wx.onMenuShareQQ(Object.assign({}, shareOptions, { shareChanel: '4' }))
}

const wxSahre = (publicInfo, shareOptions) => {
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: publicInfo.app_id, // 必填，公众号的唯一标识
    timestamp: publicInfo.timestamp, // 必填，生成签名的时间戳
    nonceStr: publicInfo.nonceStr, // 必填，生成签名的随机串
    signature: publicInfo.signature, // 必填，签名，见附录1
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'previewImage'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-weapp'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2,
  })
  window.wx.ready(function () {
    setShareInfo(shareOptions)
    isInitWxShare = true
    // 分享到腾讯微博
    // window.wx.onMenuShareWeibo(Object.assign({}, shareOptions, { shareType: "2" }))
    // 分享到QQ空间
    // window.wx.onMenuShareQZone(Object.assign({}, shareOptions, { shareType: "2" }))
  })
}

// 设置head的参数，用于qq分享
const setShareHead = shareOptions => {
  const qq_shareName = document.querySelector('meta[itemprop="name"]')
  const qq_shareDescription = document.querySelector('meta[itemprop="description"]')
  const qq_shareImage = document.querySelector('meta[itemprop="image"]')
  qq_shareName.setAttribute('content', shareOptions.title)
  qq_shareDescription.setAttribute('content', shareOptions.desc)
  qq_shareImage.setAttribute('content', shareOptions.imgUrl)
  // document.title = shareOptions.title
}

const initWxShare = async shareOptions => {
  if (!isInitWxShare) {
    const getWxPublic_result = await getWxPublic()
    if (!getWxPublic_result) return
    wxSahre(getWxPublic_result, shareOptions)
  } else {
    setShareInfo(shareOptions)
  }
  setShareHead(shareOptions)
}

export default initWxShare
